import { render } from "./SubKomponen.vue?vue&type=template&id=64a26268"
import script from "./SubKomponen.vue?vue&type=script&lang=js"
export * from "./SubKomponen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__